<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <h6>平台管理人員 (Platform Staff)</h6>
            <button
              class="btn btn-sm btn-primary"
              @click="openModal()"
              v-if="can('staff.manage')"
            >
              <i class="fas fa-plus me-2"></i>新增管理員
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      姓名/信箱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      角色 (Role)
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      建立時間
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in staffList" :key="user.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <div
                            class="avatar avatar-sm me-3 bg-gradient-secondary rounded-circle"
                          >
                            {{ user.name.charAt(0) }}
                          </div>
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.email }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        class="badge badge-sm bg-gradient-info"
                        v-if="user.user_role"
                        >{{ user.user_role.name }}</span
                      >
                      <span class="badge badge-sm bg-secondary" v-else
                        >No Role</span
                      >
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm bg-gradient-success"
                        >Active</span
                      >
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        formatDate(user.created_at)
                      }}</span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs me-3"
                        @click="openModal(user)"
                        v-if="can('staff.manage')"
                      >
                        編輯
                      </a>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deleteUser(user)"
                        v-if="can('staff.manage')"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                  <tr v-if="staffList.length === 0">
                    <td colspan="5" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Staff Modal -->
    <div
      v-if="showModal"
      class="modal fade show d-block bg-dark-overlay"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEditing ? "編輯管理員" : "新增管理員" }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="showModal = false"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <label class="form-label">姓名</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="form.email"
                  required
                  :disabled="isEditing"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">角色 (Role)</label>
                <select class="form-select" v-model="form.role_id" required>
                  <option value="" disabled>請選擇角色</option>
                  <option v-for="role in roles" :key="role.id" :value="role.id">
                    {{ role.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">
                  {{ isEditing ? "重設密碼 (若不修改請留空)" : "密碼" }}
                </label>
                <input
                  type="password"
                  class="form-control"
                  v-model="form.password"
                  placeholder="若是現有會員無需輸入密碼"
                />
                <small v-if="!isEditing" class="text-muted d-block mt-1">
                  * 若 Email 已存在，將直接提升該會員為管理員，無需設定密碼。
                </small>
              </div>
              <!-- Warning for Super Admin edits if needed -->
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="showModal = false"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary" @click="submitForm">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";
import { hasPermission } from "@/utils/permissions";

export default {
  name: "StaffManagement",
  data() {
    return {
      staffList: [],
      roles: [],
      showModal: false,
      isEditing: false,
      form: {
        id: null,
        name: "",
        email: "",
        role_id: "",
        password: "",
      },
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchStaff() {
      try {
        const res = await request.get("/api/admin/staff");
        this.staffList = res.data.data.data; // Pagination structure
      } catch (e) {
        console.error(e);
      }
    },
    async fetchRoles() {
      try {
        const res = await request.get("/api/admin/roles");
        this.roles = res.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    openModal(user = null) {
      this.fetchRoles(); // Ensure roles are fresh
      if (user) {
        this.isEditing = true;
        this.form = {
          id: user.id,
          name: user.name,
          email: user.email,
          role_id: user.role_id,
          password: "",
        };
      } else {
        this.isEditing = false;
        this.form = {
          id: null,
          name: "",
          email: "",
          role_id: "",
          password: "",
        };
      }
      this.showModal = true;
    },
    async submitForm() {
      try {
        if (this.isEditing) {
          await request.put(`/api/admin/staff/${this.form.id}`, this.form);
        } else {
          await request.post("/api/admin/staff", this.form);
        }
        this.showModal = false;
        this.fetchStaff();
        Swal.fire("Success", "操作成功", "success");
      } catch (e) {
        Swal.fire("Error", e.response?.data?.message || "操作失敗", "error");
      }
    },
    async deleteUser(user) {
      const result = await Swal.fire({
        title: "確定刪除?",
        text: `確定要刪除 ${user.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "刪除",
      });

      if (result.isConfirmed) {
        try {
          await request.delete(`/api/admin/staff/${user.id}`);
          this.fetchStaff();
          Swal.fire("Deleted!", "已刪除", "success");
        } catch (e) {
          Swal.fire("Error", e.response?.data?.message || "刪除失敗", "error");
        }
      }
    },
  },
  mounted() {
    this.fetchStaff();
  },
};
</script>

<style scoped>
.bg-dark-overlay {
  background: rgba(0, 0, 0, 0.5);
}
</style>
